
import React from 'react'
import icon from './svgs/bell.svg'
import { BaseIcon } from './_base'

export const BellIcon = ({ size, fontSize ,sx}) => {
    return (
        <BaseIcon icon = {icon} {...{fontSize,size,...sx}} />
    )
}
